module.exports = __webpack_public_path__ + "static/media/awards.01d21c7a.png";